import React, { useEffect, useState } from 'react';
import ColorPicker from '../../../../shared/ui-builder/color-picker/Color-Picker';
import RedirectSelector from '../../../../shared/ui-builder/redirect-selector/Redirect-Selector';
import '../Component-Library.scss';
import CustomUiBuilderTextField from '../../../../shared/form-controls/custom-ui-builder-text-field/Custom-UI-Builder-Text-Field';
import CTASelector from '../../../../shared/ui-builder/cta-selector/CTA-Selector';
import { IMAGE_LARGE_W_TITLE_SUBTITLE_BODY } from '../../../../constants/UiBuilderConst';
import MediaSelector from '../../../../shared/ui-builder/media-selector/Media-Selector';

//10 - Large Image w/Body,CTA, H3
const LargeImageComponentWithTitleSubtitleBody = (props) => {
  const { onItemChange, config, groupId, handleError, componentNdx } = props;

  const initialState = {
    titleH1: '',
    titleH3: '',
    body: '',
    backgroundColor: '#8f8f8f',
    imgURL: null,
    videoURL: null,
    redirectLink: {
      connection: '',
      linkId: '',
      isActive: false,
    },
    cta: {
      isActive: false,
      title: '',
    },
    shadowOverlay: false,
    loopPlayBack: false,
    isVideo: false,
  };

  const [configState, setConfigState] = useState(config.backgroundColor ? config : initialState);
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [error, setError] = useState(null);
  const [isSwapEnabled, setIsSwapEnabled] = useState(false);

  useEffect(() => {
    onItemChange({
      componentName: IMAGE_LARGE_W_TITLE_SUBTITLE_BODY,
      config: configState,
    });
  }, [configState]);

  useEffect(() => {
    if (handleError && handleError.length > 0) {
      const currError = handleError.find(
        (getError) =>
          getError.pos === componentNdx && getError.id === IMAGE_LARGE_W_TITLE_SUBTITLE_BODY,
      );
      setError(currError ?? null);
    }
  }, [handleError]);

  const setErrorField = (field, val) => {
    if (field !== 'redirect') {
      const trimmed = typeof val === 'string' ? val?.trim() : val;
      return trimmed ? '' : 'required';
    }
    return val?.type ? '' : 'required';
  };

  const handleTabData = (val, slideContent, field) => {
    const raw =
      field === 'titleH1' || field === 'titleH3' || field === 'body' ? val?.target?.value : val;
    const currError = setErrorField(field, raw);
    setError({
      config: { ...(error?.config || {}), [field]: currError },
      slides: error?.slides || [],
    });
    const tempConfigState = { ...configState };
    switch (field) {
      case 'backgroundColor':
        tempConfigState.backgroundColor = val;
        break;
      case 'titleH1':
        tempConfigState.titleH1 = val.target.value;
        break;
      case 'titleH3':
        tempConfigState.titleH3 = val.target.value;
        break;
      case 'body':
        tempConfigState.body = val.target.value;
        break;
      case 'imgURL':
        tempConfigState.imgURL = val;
        if (val) setIsSwapEnabled(false);
        break;
      case 'redirect':
        tempConfigState.redirectLink.connection = val.type;
        tempConfigState.redirectLink.linkId = val.value;
        break;
      case 'isCTAActive':
        tempConfigState.redirectLink.isActive = val;
        tempConfigState.cta.isActive = val;
        setError((prev) => ({
          config: { ...prev?.config, CTA: '' },
          slides: prev?.slides || [],
        }));
        break;
      case 'CTA':
        tempConfigState.cta.title = val;
        break;
      case 'shadowOverlay':
        tempConfigState.shadowOverlay = val;
        break;
      case 'isVideo':
        tempConfigState.isVideo = val;
        break;
      case 'videoURL':
        tempConfigState.videoURL = val;
        break;
      case 'loopPlayBack':
        tempConfigState.loopPlayBack = val;
        break;
      default:
        break;
    }
    setConfigState(tempConfigState);
  };

  const hasError = (key) => {
    if (key === 'imgURL' && error?.config[key] === 'required') {
      return true;
    } else if (key === 'videoURL' && error?.config[key] === 'required') {
      return true;
    } else if (key === 'videoURL' && error?.config[key] === 'validUrl') {
      return 'validUrl';
    }
    return false;
  };

  return (
    <>
      <div className='row my-2 mx-4'>
        <div className='col-md-12 mb-4'>
          <CustomUiBuilderTextField
            label='H1 Title'
            required={true}
            className='col-md-12'
            value={configState.titleH1}
            onChangeInput={(e) => handleTabData(e, configState, 'titleH1')}
            maxLength={40}
            isAdornment={true}
            endAdornment={true}
            error={error?.config?.titleH1 === 'required' ? true : false}
          />
          <CustomUiBuilderTextField
            label='H3 Title'
            required={true}
            className='col-md-12 mt-3'
            value={configState.titleH3}
            onChangeInput={(e) => handleTabData(e, configState, 'titleH3')}
            maxLength={100}
            isAdornment={true}
            endAdornment={true}
            error={error?.config?.titleH3 === 'required' ? true : false}
          />
          <CustomUiBuilderTextField
            label='Body1'
            required={true}
            className='col-md-12 mt-3'
            value={configState.body}
            onChangeInput={(e) => handleTabData(e, configState, 'body')}
            maxLength={500}
            isAdornment={true}
            endAdornment={true}
            multiline={true}
            error={error?.config?.body === 'required' ? true : false}
          />
        </div>
        <div className='col-md-12'>
          <div className='col-md-12 background-color-titleH2 mb-2'>Background Color</div>
          <div
            className='color-preview d-flex justify-content-center align-items-center shadow mb-1'
            style={{
              backgroundColor: configState.backgroundColor,
              cursor: 'pointer',
            }}
            onClick={() => setShowColorPicker(!showColorPicker)}
          >
            <span className='color-preview-label'>{configState.backgroundColor}</span>
          </div>
          <div className='row mt-4 mb-3'>
            <div className='col-md-12 pe-1 mt-3'>
              <div className='col-md-12'>
                <div className='col-md-12 mt-4'>
                  <MediaSelector
                    groupId={groupId}
                    titleH2={'Image'}
                    height={450}
                    width={676}
                    handleTabData={handleTabData}
                    activeTabContent={configState}
                    isSwapEnabled={isSwapEnabled}
                    setIsSwapEnabled={setIsSwapEnabled}
                    hasError={hasError}
                    ratio={'3:2'}
                    matrix={'px'}
                  />
                </div>
                <div className='col-md-12 mt-4'>
                  <CTASelector
                    onValueChange={(e) => handleTabData(e, configState, 'CTA')}
                    value={configState.cta.title}
                    onCTAStatusChange={(e) => {
                      handleTabData(e, configState, 'isCTAActive');
                    }}
                    isActive={configState.cta.isActive}
                    error={error?.config?.CTA === 'required' ? true : false}
                  />
                </div>
                {configState.cta.isActive && (
                  <div className='col-md-12 mt-4'>
                    <RedirectSelector
                      areButtonsDisabled={true}
                      onValueChange={(e) => handleTabData(e, configState, 'redirect')}
                      redirectType={configState.redirectLink.connection}
                      value={configState.redirectLink.linkId}
                      onRedirectChange={(e) => {
                        handleTabData(e, configState, 'isActive');
                      }}
                      isActive={configState.redirectLink.isActive}
                      error={error?.config?.redirect === 'required' ? true : false}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {showColorPicker && (
        <ColorPicker
          backgroundColor={configState.backgroundColor}
          onColorChange={(e) => handleTabData(e, configState, 'backgroundColor')}
          showColorPicker={showColorPicker}
          setShowColorPicker={setShowColorPicker}
        />
      )}
    </>
  );
};

export default LargeImageComponentWithTitleSubtitleBody;
